import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function NoticePeriods({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.RefDataManagement.NoticePeriods.noticePeriodName'
      ),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName={t(
        'dashboardComponents.Console.RefDataManagement.NoticePeriods.noticePeriod'
      )}
      getDataHandler={AdminService.getNoticePeriods}
      deleteDataHandler={AdminService.deleteNoticePeriod}
      createDataHandler={AdminService.createNoticePeriod}
      updateDataHandler={AdminService.updateNoticePeriod}
      viewLeftColumnFields={[{ label: 'Notice Period Name', field: 'name' }]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.NoticePeriods.noticePeriodName'
          ),
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.NoticePeriods.noticePeriodNameHere'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.NoticePeriods.specifySortOrderHere'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.NoticePeriods.enterAnySpecificNotesAboutTheNoticePeriod'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
